/* eslint no-param-reassign: 'off', no-console: 'off' */
import Vuex from 'vuex';

const homeStore = new Vuex.Store({
  state: {
    accessStats: null,
    accessStatsLoading: false,
    accessStatsLoadingError: null
  },
  mutations: {
    fetchAccessStats(state, payload) {
      state.accessStats = payload;
    }
  },
  actions: {
    async fetchAccessStats({ state, commit }) {
      try {
        state.accessStatsLoading = true;
        const res = await fetch('/v2/info/accessStats');
        if (!res.ok) throw new Error(await res.text());
        const data = await res.json();
        commit('fetchAccessStats', data);
        return data;
      } catch (ex) {
        state.accessStatsLoadingError = ex;
        return { isError: true, ex };
      } finally {
        state.accessStatsLoading = false;
      }
    }
  }
});

export default homeStore;
export const useHomeStore = () => homeStore;
